const InitCredoHeroSectionFunctionality = () => {

    const credoHeroSections = document.querySelectorAll(".dsd-credo-hero");

    if (!credoHeroSections || credoHeroSections.length <= 0) {
        return;
    }

    credoHeroSections.forEach(credoHeroSection => {
        const credoHeroSectionArrowBtn = credoHeroSection.querySelector(".dsd-credo-hero__btn");

        if (credoHeroSectionArrowBtn) {

            let scrollToTopVal = credoHeroSection.clientHeight;
            const scrollTargetID = credoHeroSectionArrowBtn.dataset.scrollTargetId;

            if (scrollTargetID) {

                const scrollTargetEl = document.querySelector("#" + scrollTargetID);
                if (scrollTargetEl) {
                    const scrollTargetElRect = scrollTargetEl.getBoundingClientRect();
                    scrollToTopVal = scrollTargetElRect.top;
                }

            }

            // Scrolling window from top to "credoHeroSectionHeight" pixels
            credoHeroSectionArrowBtn.addEventListener("click", () => {
                window.scrollTo({
                    top: scrollToTopVal,
                    behavior: "smooth"
                });
            });
        }
    });

}

export default InitCredoHeroSectionFunctionality;